{
  "actions": {
    "add": "Legg til",
    "open": "Åpne",
    "openType": "Åpne {{type, lowercase}}",
    "edit": "Redigere",
    "remove": "Fjerne",
    "abort": "Avbryt",
    "close": "Lukk",
    "clear": "Tøm",
    "create": "Ny",
    "createNew": "Opprett ny {{documentType}}",
    "search": "Søk",
    "sort": "Sortere",
    "sortBy": "Sortere etter {{label}}",
    "presetSort": "Forhåndsinnstilt sortering",
    "grouping": "Velg gruppering",
    "nogrouping": "Ingen gruppering",
    "group": "Gruppe",
    "copy": "Kopiere",
    "confirm": "Ferdig",
    "markAsDone": "Legg som klar",
    "move": "Flytte",
    "yes": "Ja",
    "no": "Nei",
    "approve": "Godkjenn",
    "saveType": "Lagre {{type}}",
    "save": "Lagre",
    "publish": "Publiser"
  },
  "misc": {
    "unknown": "ukjent",
    "user": "bruker",
    "numberOf": "Antall",
    "from": "Fra",
    "new": "Ny",
    "selected": "valgt",
    "since": "siden",
    "missing": "Mangler",
    "loading": "Laster inn...",
    "titleMissing": "Tittel mangler",
    "fetchingSession": "Henter sesjon...",
    "fetchingUserData": "Henter brukerdata...",
    "headingAndContent": "Overskrift og innhold",
    "markedAsCancelled": "Merket som avlyst",
    "error": "Feil",
    "selectTime": "Velg tid",
    "selectDates": "Velg datoer",
    "searching": "Søker...",
    "nothingFound": "Ingenting ble funnet"
  },
  "advancedSearch": {
    "title": "Avansert søk",
    "structured": "Strukturert",
    "querySyntax": "Spørringssyntaks",
    "query": "Spørring",
    "searchIn": "Søk i",
    "matchType": "Samsvartype",
    "words": "Ord",
    "exactPhrase": "Eksakt frase",
    "requireAllTerms": "Krev alle termer (AND)",
    "fuzzyMatching": "Fuzzy-samsvar",
    "fuzzyAuto": "Auto",
    "fuzzyEdit1": "~1 endring",
    "fuzzyEdit2": "~2 endringer",
    "prefixLength": "Lås første N tegn",
    "boost": "Relevansøkning",
    "dateRange": "Datoperiode",
    "fieldExists": "Felt finnes/mangler",
    "exists": "Har",
    "missing": "Mangler",
    "moreOptions": "Flere alternativer",
    "cancel": "Avbryt",
    "search": "Søk",
    "searchTerms": "Søketermer...",
    "namePlaceholder": "Gi søket et navn (valgfritt)",
    "querySyntaxPlaceholder": "title:\"ukraine\" AND content:crisis*",
    "syntaxReference": "Syntaksreferanse",
    "syntaxOperators": "Operatorer",
    "syntaxOperatorsValue": "AND, OR, NOT",
    "syntaxPhrase": "Frase",
    "syntaxPhraseValue": "\"eksakt frase\"",
    "syntaxWildcard": "Jokertegn",
    "syntaxWildcardValue": "ukrai* , cr?sis",
    "syntaxFuzzy": "Fuzzy",
    "syntaxFuzzyValue": "ord~2",
    "syntaxGrouping": "Gruppering",
    "syntaxGroupingValue": "(a OR b) AND c",
    "syntaxFieldSearch": "Feltsøk",
    "syntaxFieldSearchValue": "felt:verdi",
    "syntaxAvailableFields": "Tilgjengelige felt",
    "hints": {
      "searchIn": "Velg hvilke dokumentfelt det skal søkes i",
      "words": "Finner det best samsvarende feltet for søketermene dine",
      "exactPhrase": "Krever at ordene forekommer i nøyaktig rekkefølge",
      "requireAllTerms": "Alle søketermer må være til stede (standard er hvilken som helst term)",
      "fuzzyMatching": "Tillater omtrentlige treff, f.eks. skrivefeil",
      "fuzzyDisabledForPhrase": "Fuzzy-samsvar er ikke tilgjengelig for eksakt frase-søk",
      "fuzzyEdits": "Antall tegnendringer som tillates per ord",
      "prefixLength": "Antall starttegn som må samsvare nøyaktig før fuzzy-samsvar aktiveres",
      "boost": "Multiplikator for relevanspoeng — høyere verdier rangerer treff høyere",
      "fieldExists": "Filtrer dokumenter etter om et felt har innhold eller er tomt",
      "searchInDisabledForMissing": "Kan ikke søke i et felt som må mangle"
    },
    "notices": {
      "dateRangeNotConverted": "Datointervallet er ikke en del av søkesyntaksen og blir ikke brukt."
    },
    "modeChange": {
      "title": "Bytt søkemodus?",
      "description": "Søkesyntaksen kan ikke vises i skjemaet. Bytter du modus, forkastes den og du starter et nytt, tomt søk. Søket som allerede brukes, påvirkes ikke.",
      "confirm": "Bytt modus"
    },
    "badge": {
      "fuzzy": "Fuzzy (~{{edits}})",
      "fuzzyAuto": "Fuzzy (auto)",
      "fields": "Felt: {{fields}}",
      "boost": "Boost: {{boost}}x"
    },
    "fields": {
      "title": "Tittel",
      "content": "Innhold",
      "slugline": "Slugg",
      "description": "Beskrivelse",
      "assignment": "Oppdrag",
      "subject": "Emne",
      "table": "Tabell"
    }
  }
}
